// extracted by mini-css-extract-plugin
export default {"moreDetails":"MoreDetails_moreDetails__jw0Fp"};